export default "__VITE_ASSET__CdZkpnTJ__"